const defaultState = {

};

const documentReducer = (state = defaultState, action) => {
    
  switch (action.type) {
    case "SET_DOCUMENTS":
      return {
        ...state,
        ...action.documents,
      };
    default:
      return { ...state };
  }
};

export default documentReducer;
